import React from 'react'

const Biography = ({
    user = {}
}) => {

    return (
        <div className='three-line-ellipsis' style={{ color: 'black'}}>
            {user.biography}
        </div>
    )
}

export default Biography